import { isPlatform } from '@ionic/react';
import { addPro, removeProBackend } from './../redux/actions/logInActions';
import { initiateStore } from './../redux/actions/proActions';
import { isInThePast, sendStoreUpdate, storeType, subscriptionId } from './shop_helper';
import store from '../redux/store'
import "cordova-plugin-purchase"
import { initializeStore } from './shop_helper_2';
declare interface Window { store: CdvPurchase.Store; }

const Store: CdvPurchase.Store = window.store
const state = store.getState()

export const checkStore = async () => {
  let auth: boolean = true
  if(state.store.storeReady) {
    auth = checkOwned()
  } else {
    if(isPlatform('capacitor')) {
      await initiateStore(state.logIn.user.WTTeams).then(res => {
        if(res === true) {
          auth = checkOwned()
        } else {
          auth = false
        }
      }).catch(e => auth = false)
    } else {
      auth = false
    }
  }

  return auth 
}

const checkOwned = () => {
  let owned = false
  if(Store.owned(subscriptionId()) === true) {
    owned = true
  } else {
    owned = false
  }
  return owned
}

const checkExpired = (expiryDate: Date) => {
  let auth: boolean = false

  if(expiryDate !== null) {
    if(isInThePast(expiryDate)) {
      auth = false
    } else {
      auth = true
    }
  } else {
    auth = false
  }

  return auth
}

export const hasProAuth = async (Pro: boolean, expiryDate: null | Date, proId: number) => {
  let auth: boolean = true

  if(Pro === true){
    if(await checkStore() === true) {
      auth = true
    } else {
      if(checkExpired(expiryDate as Date)) {
        auth = true
      } else {
        auth = false
        removeProBackend(proId)
      }
    }
  } else {
    if(!checkExpired(expiryDate as Date)) {
      if(await checkStore() === true) {
        store.dispatch(addPro(true))
        auth = true
      } else {
        auth = false
      }
    } else {
      store.dispatch(addPro(true))
      sendStoreUpdate(3, storeType(), null)
      auth = true
    }
  }

  return auth
}
